import React from 'react';
import './App.css';

function App() {
  return (
    <main className="card">
      <header className="top">
        <h1 className="name">Kunal Mansukhani</h1>
      </header>

      <div className="hair"></div>

      <section className="body">
        <p>I'm currently scaling AI4 inference infrastructure at Tesla.</p>
        <p>
          Previously, I built and scaled{' '}
          <a className="inline" href="https://leetgpu.com" target="_blank" rel="noopener noreferrer">LeetGPU</a>{' '}
          to 20K users and 350K submissions.
        </p>
        <p>On the side, I'm building something new to optimize compute efficiency.</p>
        <p className="cta">If any of this is interesting to you, let's talk.</p>
      </section>

      <footer className="footer">
        <div className="hair"></div>
        <div className="footmeta">
          <nav className="links" aria-label="Contact">
            <a href="mailto:kmmansukhani@gmail.com">Email</a>
            <a href="https://x.com/therealkmans" target="_blank" rel="noopener noreferrer">Twitter</a>
            <a href="https://github.com/kunal-mansukhani" target="_blank" rel="noopener noreferrer">GitHub</a>
            <a href="https://www.linkedin.com/in/kunal-mansukhani-b03656220/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          </nav>
        </div>
      </footer>
    </main>
  );
}

export default App;
